module.exports = __webpack_public_path__ + "img/lightbulb.72e7ada7.svg";